// Emit “font-loaded” event so expandable components know to recalc their height
document.fonts.ready.then(function() {
  let fontEvent = new CustomEvent('fonts-loaded');
  document.documentElement.dispatchEvent(fontEvent);
});

// Detect input method in order to hide outlines in an accessible manner
// https://github.com/ten1seven/what-input
import 'what-input';

// Modules
import './modules/animate-on-scroll';
import './modules/back-to-top';
import './modules/background-picture';
import './modules/checklist-print';
import './modules/checklist-save';
import './modules/classy-donate';
import './modules/comparison-vertical-bar-chart';
import './modules/disease-fund-detail';
import './modules/donate-utm';
// import './modules/donation-form';
import './modules/doughnut-chart';
import './modules/eligibility-wizard';
import './modules/external-links';
import './modules/facet-wp';
import './modules/faq-block';
import './modules/faq-search';
import './modules/feature-grid';
import './modules/featured-resources-hover';
import './modules/flip-card';
import './modules/fluid-iframes';
import './modules/fluid-svg-polyfill';
import './modules/form-autosubmit';
import './modules/form-parameters';
import './modules/form-validation';
import './modules/fund-medication-listing';
import './modules/fund-prospective-listing';
import './modules/fund-quick-search';
import './modules/get-help';
import './modules/glossary';
import './modules/gravity-form-contact-us';
import './modules/homepage-banner';
import './modules/horizontal-bar-chart';
import './modules/inline-term';
import './modules/jumpnav';
import './modules/link-icons';
import './modules/nav';
import './modules/pie-chart';
import './modules/post-carousel';
import './modules/resource-list-match-height';
import './modules/search-facets';
import './modules/show-all';
import './modules/stacked-horizontal-bar-chart';
import './modules/subnav';
import './modules/tabbed';
import './modules/tabbed-mobile';
import './modules/tooltips';
import './modules/top-hat';
import './modules/vertical-bar-chart';
import './modules/youtube';
import './modules/z-index-on-hover';
